(() => {
  if (window.dayloCartPageBound) return;
  window.dayloCartPageBound = true;
  const locked = (page) => page?.getAttribute('aria-busy') === 'true' || page?.dataset.cartPageStale === 'true';
  const sync = (input) => {
    const control = input.closest('.daylo-cart-page-quantity');
    if (!control || input.disabled || locked(input.closest('[data-daylo-cart-page]'))) return;
    const value = Number(input.value);
    const minimum = Number(input.min) || 1;
    const increment = Number(input.step) || 1;
    const maximum = input.max === '' ? Infinity : Number(input.max);
    const decrease = control.querySelector('[data-cart-page-quantity-delta="-1"]');
    const increase = control.querySelector('[data-cart-page-quantity-delta="1"]');
    if (decrease) decrease.disabled = value - increment < minimum;
    if (increase) increase.disabled = value + increment > maximum;
  };
  const markChanged = (input) => {
    const page = input.closest('[data-daylo-cart-page]');
    const hint = page?.querySelector('[data-cart-page-update-hint]');
    if (hint) hint.hidden = false;
    if (input.name === 'updates[]') sync(input);
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-daylo-cart-page] [data-cart-page-quantity-delta]');
    if (!button || button.disabled || locked(button.closest('[data-daylo-cart-page]'))) return;
    const input = button.closest('.daylo-cart-page-quantity')?.querySelector('input[name="updates[]"]');
    if (!input || input.disabled) return;
    const minimum = Number(input.min) || 1;
    const increment = Number(input.step) || 1;
    const maximum = input.max === '' ? Infinity : Number(input.max);
    const current = Number(input.value);
    const currentAligned = Number.isFinite(current) ? minimum + Math.round((current - minimum) / increment) * increment : minimum;
    const alignedMaximum = Number.isFinite(maximum) ? minimum + Math.floor((maximum - minimum) / increment) * increment : Infinity;
    input.value = String(Math.min(alignedMaximum, Math.max(minimum, currentAligned + Number(button.dataset.cartPageQuantityDelta) * increment)));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-daylo-cart-page] input[name="updates[]"], [data-daylo-cart-page] textarea[name="note"]')) markChanged(event.target);
  });
})();
